import React, { Component } from 'react';
import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';
import BurgerBarMobile from '../../../../Assets/Images/Thinkup/BurgerBarMobile.png';
import HomeMobile from '../../../../Assets/Images/Thinkup/HomeMobile.png';
import MatrixTablet from '../../../../Assets/Images/Thinkup/MatrixTablet.png';
import GifDesktop from '../../../../Assets/Images/Thinkup/ThinkupDesktop.gif';
import device from '../../../../Assets/Responsive/breakpoints';

const Gif = styled.img.attrs({
  style: ({ scroll }) => ({
    transform: `translate(0px,-${scroll * 27}%)`
  })
})`
  transition: transform 0.2s ease-out;
  position: absolute;
  bottom: -170vh;
  left: 0vw;
  /* border: 1px dashed red; */
  height: 60vh;
  border-radius: 25px;
  @media ${device.mobileMaxWidth} {
    transform-origin: left center;
    width: 100vw;
    height: 30vh;
    bottom: -30vh;
    border-radius: 12px;
  }
`;

const Matrix = styled.img.attrs({
  style: ({ scroll }) => ({
    transform: `translate(0px,-${scroll * 10}%) scale(0.7)`
  })
})`
  bottom: -150vh;
  left: -4vw;
  position: absolute;
  /* border: 1px dashed red; */
  height: 90vh;
  /* filter: blur(0.8px); */
  @media ${device.mobileMaxWidth} {
    width: 100vw;
    height: 60vh;
    bottom: -60vh;
  }
`;
const Home = styled.img.attrs({
  style: ({ scroll }) => ({
    transform: `translate(0px,-${scroll * 5}%) scale(0.94)`
  })
})`
  transition: transform 0.2s ease-out;
  position: absolute;
  bottom: -40vh;
  right: 3vw;
  /* border: 1px dashed red; */
  height: 60vh;
  /* filter: blur(0.6px); */
  @media ${device.mobileMaxWidth} {
    height: 50vh;
    bottom: -30vh;
  }
`;
const BurgerBar = styled.img.attrs({
  style: ({ scroll }) => ({
    transform: `translate(0px,-${scroll * 7}%) scale(0.7)`
  })
})`
  transition: transform 0.2s ease-out;
  bottom: -100vh;
  left: 0vw;
  position: absolute;
  /* border: 1px dashed red; */
  height: 60vh;
  /* filter: blur(0.8px); */
`;

class ThinkupImages extends Component {
  render() {
    let { scrollPercent } = this.props;
    const { boxHeight, index, scrollHeight, screenHeight } = this.props;
    const heighttoBeReducedinVH = boxHeight * index - 100;
    const scrollOffset = (screenHeight * heighttoBeReducedinVH) / 100;
    const scrollOffsetInPercent = (scrollOffset * 100) / scrollHeight;
    scrollPercent -= scrollOffsetInPercent;
    return (
      <React.Fragment>
        <Home src={HomeMobile} scroll={scrollPercent} alt="HomeMobile" />
        <BurgerBar src={BurgerBarMobile} scroll={scrollPercent} alt="BurgerBarMobile" />
        <Matrix src={MatrixTablet} scroll={scrollPercent} alt="MatrixTablet" />
        <Gif src={GifDesktop} scroll={scrollPercent} alt="GifDesktop" />
      </React.Fragment>
    );
  }
}

ThinkupImages.propTypes = {
  boxHeight: PropTypes.number.isRequired,
  index: PropTypes.number.isRequired,
  screenHeight: PropTypes.number.isRequired,
  scrollHeight: PropTypes.number.isRequired,
  scrollPercent: PropTypes.number.isRequired
};

export default ThinkupImages;
